import React from 'react'
import injectSheet from 'react-jss'
import Button from 'react-validation/build/button'
import Form from 'react-validation/build/form'
import Input from 'react-validation/build/input'
import {
  ContentContainer,
  FormInputContainer,
  InfoContainer,
  TextButton,
} from '../../'
import {
  validEmail,
  isRequired,
} from '../../../utils/validations'

import './loginAutofill.css'

class Login extends React.Component {
  constructor() {
    super()

    this.state = {
      email: '',
      password: '',
      hasAutofill: false,
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.removeError = this.removeError.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleAutofillSubmit = this.handleAutofillSubmit.bind(this)
    this.handleAutofill = this.handleAutofill.bind(this)
  }

  componentDidMount() {
    window.addEventListener('animationstart', this.handleAutofill)
  }

  componentWillUnmount() {
    window.removeEventListener('animationstart', this.handleAutofill)
  }

  handleAutofill(e) {
    if (e.animationName === 'onAutoFillStart') {
      this.setState({
        hasAutofill: true,
      })
    }
    if (e.animationName === 'onAutoFillCancel') {
      this.setState({
        hasAutofill: false,
      })
    }
  }

  handleSubmit(event) {
    event.preventDefault()
    this.props.login(this.state)
  }

  handleAutofillSubmit() {
    this.props.login(this.state)
  }

  handleInputChange(event) {
    const {
      name,
      value,
    } = event.target

    this.setState({
      [name]: value,
    })
  }

  removeError() {
    this.form.hideError(this.userInput)
  }

  render() {
    const {
      classes,
      form,
      error,
    } = this.props

    const {
      email,
      password,
      hasAutofill,
    } = this.state

    return (
      <ContentContainer small>
        <InfoContainer warning>
          {(error && <div className={classes.error}>Login-Versuch fehlgeschlagen</div>)}
          <div>{form && form.intro}</div>
          <Form
            ref={(c) => { this.form = c }}
            onSubmit={this.handleSubmit}
          >
            <div className={`${classes.inputContainer}`}>
              <FormInputContainer
                label="Email*"
                forHtml="email"
                filled={hasAutofill || email}
              >
                <Input
                  id="email"
                  onFocus={this.removeError}
                  onChange={this.handleInputChange}
                  ref={(c) => { this.userInput = c }}
                  type="text"
                  value={email}
                  name="email"
                  validations={[isRequired, validEmail]}
                />
              </FormInputContainer>
              <FormInputContainer
                label="Passwort*"
                forHtml="password"
                filled={hasAutofill || password}
              >
                <Input
                  id="password"
                  onFocus={this.removeError}
                  onChange={this.handleInputChange}
                  ref={(c) => { this.userInput = c }}
                  type="password"
                  value={password}
                  name="password"
                  validations={[isRequired]}
                />
              </FormInputContainer>
            </div>
            <div className={`${classes.inputContainer} submit`}>
              <FormInputContainer>
                {hasAutofill ? (
                  <TextButton
                    index={0}
                    text={form && form.submitButton}
                    handleClick={this.handleAutofillSubmit}
                    primary
                  />
                ) : (
                  <Button>{form && form.submitButton}</Button>
                )}
              </FormInputContainer>
            </div>
          </Form>
        </InfoContainer>
      </ContentContainer>
    )
  }
}

const styles = theme => ({
  inputContainer: {
    '&.submit': {
      '& .button': {
        padding: 0,
        '& div[role="button"]': {
          padding: `${theme.sizes.gutter / 4}px ${theme.sizes.gutter}px`,
          width: 'fit-content',
          '& span': {
            display: 'block',
          },
        },
      },
    },
  },
  error: {
    color: theme.colors.main_1,
    paddingBottom: '20px',
  },
})


export default injectSheet(styles)(Login)



// WEBPACK FOOTER //
// ./src/modules/admin/components/login.jsx